import { render, staticRenderFns } from "./Todoist.vue?vue&type=template&id=645ae7bc"
import script from "./Todoist.vue?vue&type=script&lang=js"
export * from "./Todoist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports